import React, { Component } from 'react';
import CloudPanel from '@components/CloudPanel/CloudPanel';
import {
  Row,
  Col,
  Container,
  InputGroup,
  Input,
  InputGroupAddon
} from 'reactstrap';
import ProgressBox from '@components/ProgressBox/ProgressBox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class WelcomeToSuitekey extends Component {
  state = {
    formData: {
      Email: '',
      FirstName: '',
      LastName: '',
      Frequent_Routes__c: '',
      Frequent_Passengers__c: ''
    },
    status: 0
  };

  updateForm = (event, name) => {
    const currentData = { ...this.state.formData };

    currentData[name] = event.target.value;

    this.setState({
      formData: { ...currentData }
    });
  };

  submitHandler = () => {
    let myForm = window.marketo.getForm(1005);
    myForm.addHiddenFields({ ...this.state.formData });
    myForm.submit();
  };

  componentDidMount = () => {
    window.addEventListener('marketo-submitted-1005', () =>
      this.submitingHandler(2)
    );
    window.addEventListener('marketo-submitting-1005', () =>
      this.submitingHandler(1)
    );
  };

  componentWillUnmount = () => {
    window.removeEventListener('marketo-submitted-1005', () =>
      this.submitingHandler(2)
    );
    window.removeEventListener('marketo-submitting-1005', () =>
      this.submitingHandler(1)
    );
  };

  submitingHandler = status => {
    this.setState({
      status: status
    });

    if (status === 2) {
      setTimeout(
        () =>
          this.setState({
            formData: {
              Email: '',
              FirstName: '',
              LastName: '',
              Frequent_Routes__c: '',
              Frequent_Passengers__c: ''
            },
            status: 0
          }),
        2000
      );
    }
  };

  render() {
    return (
      <CloudPanel
        id={'welcome-to-suitekey'}
        hideJSILogo={true}
        screenHeight={this.props.pageHeight}
      >
        <div
          className={
            this.props.pageWidth < 992
              ? 'pt-5 mt-5 mb-5'
              : 'abs-container d-flex align-items-center h-100'
          }
        >
          <Container>
            <Row>
              <Col md={10} lg={9} xl={8} className={'mx-auto'}>
                {this.state.status === 1 && (
                  <ProgressBox
                    text={'Submitting ...'}
                    icon={<FontAwesomeIcon icon={['far', 'spinner']} spin />}
                  />
                )}
                {this.state.status === 2 && (
                  <ProgressBox
                    text={'Submitted!'}
                    icon={<FontAwesomeIcon icon={['far', 'check-circle']} />}
                  />
                )}
                <div className={'background-white py-4 px-4'}>
                  <div className={'text-center font-md lakes-bold pb-1'}>
                    Welcome to the SuiteKey Membership Program!
                  </div>
                  <div className={'lakes-regular text-center'}>
                    Thank you for providing the information below to help us
                    ensure that your experience is enjoyable and hassle-free.
                  </div>
                  <div className={'lakes-regular text-center pt-2 pb-1'}>
                    As a reminder, please email a copy of your passport photo
                    page to{' '}
                    <a
                      href={'mailto:suitekey@jetsuite.com'}
                      className={'red-link'}
                    >
                      SuiteKey@JetSuite.com
                    </a>
                    .<br />
                    We will need the same for all designated lead passengers.
                  </div>
                  <div
                    className={'background-white mt-2 p-4'}
                    style={{ border: '1px solid #dddddd' }}
                  >
                    <InputGroup className={'mb-2 input-group-sm'}>
                      <InputGroupAddon
                        addonType="prepend"
                        style={{ width: '100px' }}
                        className={'pl-0'}
                      >
                        First Name
                      </InputGroupAddon>

                      <Input
                        value={this.state.formData.FirstName}
                        onChange={e => this.updateForm(e, 'FirstName')}
                      />
                    </InputGroup>

                    <InputGroup className={'mb-2 input-group-sm'}>
                      <InputGroupAddon
                        addonType="prepend"
                        style={{ width: '100px' }}
                      >
                        Last Name
                      </InputGroupAddon>

                      <Input
                        value={this.state.formData.LastName}
                        onChange={e => this.updateForm(e, 'LastName')}
                      />
                    </InputGroup>

                    <InputGroup className={'mb-2 input-group-sm'}>
                      <InputGroupAddon
                        addonType="prepend"
                        style={{ width: '100px' }}
                      >
                        Email Address
                      </InputGroupAddon>

                      <Input
                        value={this.state.formData.Email}
                        onChange={e => this.updateForm(e, 'Email')}
                      />
                    </InputGroup>

                    <label className={'d-block mb-0 font-sm'}>
                      Frequent Routes{' '}
                      <span
                        style={
                          this.props.pageWidth < 992
                            ? { color: '#a1a1a1', lineHeight: '16px' }
                            : { color: '#a1a1a1' }
                        }
                        className={this.props.pageWidth < 992 ? 'd-block' : ''}
                      >
                        <small>(One city pair or airport pair per line):</small>
                      </span>
                    </label>
                    <InputGroup className={'mb-2'}>
                      <textarea
                        value={this.state.formData.Frequent_Routes__c}
                        onChange={e => this.updateForm(e, 'Frequent_Routes__c')}
                        className={'form-control'}
                      />
                    </InputGroup>

                    <label className={'d-block mb-0 font-sm'}>
                      Frequent Passengers&nbsp;
                      <span
                        style={
                          this.props.pageWidth < 992
                            ? { color: '#a1a1a1', lineHeight: '16px' }
                            : { color: '#a1a1a1' }
                        }
                        className={this.props.pageWidth < 992 ? 'd-block' : ''}
                      >
                        <small>
                          (One person per line: first name/last name/weight/date
                          of birth):
                        </small>
                      </span>
                    </label>
                    <InputGroup className={'mb-2'}>
                      <textarea
                        value={this.state.formData.Frequent_Passengers__c}
                        onChange={e =>
                          this.updateForm(e, 'Frequent_Passengers__c')
                        }
                        className={'form-control'}
                      />
                    </InputGroup>
                  </div>

                  <div className={'text-center pt-3'}>
                    <button
                      className={'mx-auto btn btn-fullred'}
                      onClick={this.submitHandler}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </CloudPanel>
    );
  }
}

export default WelcomeToSuitekey;



// WEBPACK FOOTER //
// ./src/components/WelcomeToSuitekey/WelcomeToSuitekey.jsx